let num;
let len;
const $call = document.querySelectorAll('.js-phone');

function isPhone(){
  return navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0;
};

if(isPhone()) {
  len = $call.length;

  for(let i = 0; i < len; i++) {
    num = $call[i].innerHTML.split('-').join('');
    $call[i].outerHTML = "<a href='" + num + "'>" + $call[i].innerHTML + "</a>";
  }
}
